import { render, staticRenderFns } from "./HarmfulBacteria.vue?vue&type=template&id=5ab0e5c5&scoped=true&"
import script from "./HarmfulBacteria.vue?vue&type=script&lang=js&"
export * from "./HarmfulBacteria.vue?vue&type=script&lang=js&"
import style0 from "./HarmfulBacteria.vue?vue&type=style&index=0&id=5ab0e5c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0e5c5",
  null
  
)

export default component.exports